export default __webpack_public_path__ + "static/AA081210_Citation_680-0141-02a_540x358-23424d33dfb0074807ee5c25709448df.jpg";